import { getFormattedDate } from '@app/utils/date'
import { getFullNameFromUser, isNull, mapRoleToPosition } from '@app/utils'
import { dateFormat } from '@app/constants'

import type { InternalTasksDataSource } from '@app/pages/InternalTasksPage/types'
import type { ResponseDto } from '@app/api/dtos'
import type { InternalTasksListItemDto } from '@app/api/routes/internalTasks/dtos'
import type { TableData } from '@app/types/table'

const getExecutorFirstRole = (dto: InternalTasksListItemDto): string => {
  if (!isNull(dto.executor) && !isNull(dto.executor?.roles)) {
    return mapRoleToPosition(dto.executor.roles[0]) ?? ''
  }

  return mapRoleToPosition(dto.role) ?? ''
}

export const adaptInternalTasksTableData = (
  internalTasksListItemResponse: ResponseDto<InternalTasksListItemDto>
): TableData<InternalTasksDataSource> => {
  const { count, results: internalTasksListItem } = internalTasksListItemResponse

  const dataSource: InternalTasksDataSource[] = internalTasksListItem.map(dto => ({
    key: String(dto.id),
    name: dto.name,
    monitoringId: dto.monitoringList?.id,
    taskType: dto.taskType ?? null,
    deadline: getFormattedDate(dto.deadline, dateFormat.DD_MM_YYYY),
    executor: getFullNameFromUser(dto.executor),
    role: getExecutorFirstRole(dto),
    status: dto.status,
    initiator: getFullNameFromUser(dto.initiator),
    salesOrganization: dto.monitoringList?.salesOrganization?.name ?? null,
    monitoringType: dto.monitoringList?.monitoringType?.name ?? null,
    cluster: dto.monitoringList?.cluster?.name ?? null
  }))

  return { count, dataSource }
}
